module.exports = __webpack_public_path__ + "static/img/p5.565f4869.png";